import $ from 'jquery';
import imagesLoaded from 'imagesloaded';
import ProductItem from '../snippets/ProductItem';
import Menu from '../Menu';

export default class StaticSection {
  constructor(section) {
    this.section = section;
    this.$el = $(section.el);
    this.data = section.data;

    // Menu system
    this.states = {
      default: {
        buttonsSelector: '[data-collection-menu-buttons-default]',
        buttons: [
          {
            selector: '[data-collection-menu-button-sortby]',
            callback: () => { this.menu.changeState(this.states.sortBy); },
          },
          {
            selector: '[data-collection-menu-button-refine]',
            callback: () => { this.menu.changeState(this.states.refine); },
          },
        ],
      },
      sortBy: {
        slideoutSelector: '[data-collection-slideout-sortby]',
        buttonsSelector: '[data-collection-menu-buttons-sortby]',
        buttons: [
          {
            selector: '[data-collection-menu-slideout-button-dismiss]',
            callback: () => { this.menu.changeState(this.states.default); },
          },
          {
            selector: '[data-collection-menu-button-cancel]',
            callback: () => { this.menu.changeState(this.states.default); },
          },
          {
            selector: '[data-collection-menu-button-apply]',
            callback: () => { this._applySortByAndRefine(); },
          },
        ],
        dismiss: () => { this.menu.changeState(this.states.default); },
      },
      refine: {
        slideoutSelector: '[data-collection-slideout-refine]',
        buttonsSelector: '[data-collection-menu-buttons-refine]',
        buttons: [
          {
            selector: '[data-collection-menu-slideout-button-dismiss]',
            callback: () => { this.menu.changeState(this.states.default); },
          },
          {
            selector: '[data-collection-menu-button-cancel]',
            callback: () => { this.menu.changeState(this.states.default); },
          },
          {
            selector: '[data-collection-menu-button-apply]',
            callback: () => { this._applySortByAndRefine(); },
          },
        ],
        dismiss: () => { this.menu.changeState(this.states.default); },
      },
    };

    this.$collectionMenuContainer = $('[data-collection-menu-container]', this.$el);
    this.menu = new Menu(this.$collectionMenuContainer, this.states, this.states.default);

    // History
    this.isThemeEditor = window.Shopify && window.Shopify.designMode;
    this.useHistory = !this.isThemeEditor && history.pushState;
    this.$collectionTags = $('[data-collection-tag]', this.$el);
    this.selectedCollectionTags = [];
    this.$sortByOptions = $('[data-sortby-option]', this.$el);

    if (this.useHistory) {
      this._initTags();
    }

    // Product items
    this.productItems = [];
    const $productItems = $('[data-product-item]', this.$el);

    for (const productItem of $productItems) {
      this.productItems.push(
        new ProductItem($(productItem), this.section.postMessage)
      );
    }

    this._setSortByQueryParameters();
    this._updateSortByButtons();
    this._bindEvents();

    this.imagesLoaded = new imagesLoaded(this.$el[0], null);
    this.imagesLoaded.on('progress', () => {
      const $collectionGrid = $('[data-collection-grid]', this.$el);

      $collectionGrid.removeClass('collection-grid-uninit');
      this._positionItems();
    });
  }

  _bindEvents() {
    $(window).on('resize.collection', () => this._positionItems());

    if (this.useHistory) {
      // Handles collection tag click event
      this.$collectionTags.on('click.collection-menu', (event) => {
        const $selectedTag = $(event.currentTarget);
        const tag = $selectedTag.data('collection-tag');
        const index = this.selectedCollectionTags.indexOf(tag);

        event.preventDefault();
        event.stopPropagation();

        if (index > -1) {
          $selectedTag.removeAttr('data-collection-tag-selected');
          this.selectedCollectionTags.splice(index, 1);
        } else {
          $selectedTag.attr('data-collection-tag-selected', '');
          this.selectedCollectionTags.push(tag);
        }
      });
    }

    this.$sortByOptions.on('click.collection-menu', (event) => {
      const $selectedSortByOption = $(event.currentTarget);

      Shopify.queryParams.sort_by = $selectedSortByOption.val();
      this.$sortByOptions
        .parent()
        .removeClass('collection-sortby-option-selected');
      $selectedSortByOption
        .parent()
        .addClass('collection-sortby-option-selected');
    });
  }

  _unbindEvents() {
    $(window).off('resize.collection');
    this.$collectionTags.off('click.collection-menu');
    this.$sortByOptions.off('click.collection-menu');
  }

  _positionItems() {
    const $header = $('[data-collection-header]', this.$el);
    const $gridItems = $('[data-collection-grid-item]', this.$el);
    const headerBottom = $header[0].getBoundingClientRect().bottom;

    let foundFirstClear = false;
    let lastGridItemTop = Infinity;
    let currentRowGridItems = [];
    let tallestRowGridItemHeight = -Infinity;

    $gridItems.css({
      clear: '',
      height: '',
    });

    for (const gridItem of $gridItems) {
      const $gridItem = $(gridItem);

      const gridItemRect = gridItem.getBoundingClientRect();
      const gridItemPercentageExceeding = gridItemRect.bottom < headerBottom
        ? 0
        : (gridItemRect.bottom - headerBottom) / gridItemRect.height;

      if (lastGridItemTop != Infinity && gridItemRect.top != lastGridItemTop) {
        currentRowGridItems.forEach(($el) => $el.css('height', tallestRowGridItemHeight));
        tallestRowGridItemHeight = -Infinity;
        currentRowGridItems = [];
      }

      tallestRowGridItemHeight = Math.max(tallestRowGridItemHeight, gridItemRect.height);
      currentRowGridItems.push($gridItem);

      if (!foundFirstClear && (gridItemPercentageExceeding > 0.60 || gridItemRect.top > headerBottom)) {
        $(currentRowGridItems[0]).css('clear', 'left');
        foundFirstClear = true;
      }

      lastGridItemTop = gridItem.getBoundingClientRect().top;
    }
  }

  _initTags() {
    const $selectedTags = this.$collectionTags.filter('[data-collection-tag-selected]');

    for (const selectedTag of $selectedTags) {
      const $selectedTag = $(selectedTag);
      const tag = $selectedTag.data('collection-tag');
      this.selectedCollectionTags.push(tag);
    }
  }

  _setSortByQueryParameters() {
    Shopify.queryParams = {};
    if (location.search.length) {
      for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
        aKeyValue = aCouples[i].split('=');
        // Reset the page number when we apply (i.e. don't add it to params)
        if (aKeyValue.length > 1 && aKeyValue[0] != 'page') {
          Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
        }
      }
    }
  }

  _updateSortByButtons() {
    this.$sortByOptions
      .filter(`[value="${ this.data.sort_by }"]`)
      .prop('checked', true)
      .parent()
      .addClass('collection-sortby-option-selected');
  }

  _applySortByAndRefine() {
    const isVendor = Shopify.queryParams.q;
    let url = `${this.data.shop_url}/collections/${this.data.collection_handle}/${this.selectedCollectionTags.join('+')}?${$.param(Shopify.queryParams)}`;

    if (isVendor) {
      url = `${this.data.shop_url}/collections/all/${this.selectedCollectionTags.join('+')}?${$.param(Shopify.queryParams)}`;
    }

    window.location = url;
  }

  onSectionUnload() {
    this._unbindEvents();
    this.menu.unload();

    for (const productItem of this.productItems) {
      productItem.unload();
    }
  }
}
